import React from "react";
import * as Assets from "../../../utils/svg_assets";
import "./style.scss";

const ResultContent = (props) => {
  return (
    <div className="result-progress">
      <span className="title">{props.answer}</span>
      <div className="bar-base">
        <div className="content">
          {props.isChoosedAnswer ? (
            <div className="left-bar">
              <div className="img-wrapper">
                <img src={Assets.iconCheckCircleWhite} alt="logo_image" />
              </div>
              <div className="text-wrapper">
                <span className="text-choice">Your choice</span>
              </div>
            </div>
          ) : (
            <div className="left-bar" />
          )}
          <div className="text-progress">
            <span className="count">
              {`${props.percentage ? props.percentage : 0}`}%
            </span>
          </div>
        </div>
      </div>
      {props.percentage == 0 ? null : (
        <div
          className={`bar-progress ${props.isChoosedAnswer ? "active" : ""}`}
          style={{ width: `${props.percentage}%` }}
        />
      )}
    </div>
  );
};

export default ResultContent;
